import { z } from "zod";

export const CredentialsSchema = z.object({
    email: z.string().email("Invalid email"),
    password: z.string().min(1, "Password is required"),
    tenantId: z.number().min(1),
});

export type Credentials = z.infer<typeof CredentialsSchema>;
